import { MutationHandlingServiceV2 } from '@akebono/core';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { DateTime } from 'luxon';
import { of } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';

import { AutoLotView } from '../../../../../const';
import {
  LotSource,
  LotTypeEnum,
  LotUpdateGQL,
} from '../../../../graphql/service/graphql-auto-main-service';

@Component({
  selector: 'app-lot-edit-auction-datetime',
  templateUrl: './lot-edit-auction-datetime.component.html',
  styleUrls: ['./lot-edit-auction-datetime.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotEditAuctionDatetimeComponent implements OnInit {
  @Input() lot: AutoLotView;
  @Input() lotType: LotTypeEnum;
  @Input() lotSource: LotSource;
  @Output() actionComplete = new EventEmitter<void>();

  showPopover = false;
  auctionDatetime;
  saving = of(false);

  constructor(private mhs: MutationHandlingServiceV2, private lotUpdateGQL: LotUpdateGQL) {}

  ngOnInit(): void {
    this.auctionDatetime =
      DateTime.fromISO(this.lot.time)
        .setZone('Asia/Tokyo')
        .setZone('Local', { keepLocalTime: true })
        .toJSDate() ?? 0;
  }

  saveStartPrice(): void {
    this.saving = this.mhs
      .mutate(this.lotUpdateGQL, {
        input: {
          lotId: this.lot.id,
          lotType: this.lotType,
          lotSource: this.lotSource,
          auctionDatetime: DateTime.fromJSDate(this.auctionDatetime)
            .setZone('Asia/Tokyo', { keepLocalTime: true })
            .toJSDate(),
        },
      })
      .loading.pipe(
        finalize(() => {
          this.actionComplete.emit();
          this.showPopover = false;
        }),
        shareReplay(),
      );
  }
}
